import React from 'react';
import Script from 'react-load-script';
import PropTypes from 'prop-types';
import edapWrapper from '@homeaway/edap-wrapper';

class TrustWidget extends React.Component {
    static propTypes = {
        handlePayload: PropTypes.func.isRequired
    };

    static get defaultProps() {
        return {
            handlePayload: () => {
            }
        };
    }

    state = {
        clientSideRendering: typeof window !== 'undefined',
        payload: null
    };

    componentDidMount() {
        if (this.state.clientSideRendering) {
            this.setTrustWidgetConfig();
        }
    }

    setTrustWidgetConfig = () => {
        let trustApi = window.trustApi || {};
        // Cookie configuration assumes that document.cookie will contain info like 'foo=bar; JSESSIONID=myCookieSessionId; bar=foo;'
        trustApi.clientConfiguration = {
            'webSessionProviderMethod': 'COOKIE',
            'webSessionProviderMethodParam': 'JSESSIONID',
            'placement': 'PURCHASE',
            'placementPage': '1',
            'reportingSegment': 'www.expedia.com'
        };
        window.trustApi = trustApi;
    };
    handleScriptError = () => {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                eventaction: 'trustwidget.error',
                eventcategory: 'trustwidget',
                eventlabel: 'scriptLoadFailed'
            }
        });
        this.invokeHandlePayload();
    };
    handleScriptLoad = () => {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                eventaction: 'trustwidget.initiated',
                eventcategory: 'trustwidget'
            }
        });
        if (this.state.clientSideRendering) {
            this.setState({payload: window.trustApi.getTrustPayload()});
        }
        return this.invokeHandlePayload();
    };
    invokeHandlePayload = () => {
        this.props.handlePayload(this.state.payload);
    };

    render() {
        return (
            <Script
                url="https://www.expedia.com/trustProxy/tw.egencia.min.js"
                onError={this.handleScriptError}
                onLoad={this.handleScriptLoad}
            />
        );
    }
}

export default TrustWidget;
